export default __webpack_public_path__ + "22a0a963a878330fa542b4555e210505.jpg";